document.addEventListener('DOMContentLoaded', () => {

  /***
  TAB DESCRIPTIONS
  ***/
  const tabsContainer = document.getElementById('product-tabs-container');
  if (tabsContainer) {
    const tabLinks = tabsContainer.querySelectorAll('.product-tab');
    const tabContents = tabsContainer.querySelectorAll('.product-tab-content');

    tabLinks.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();

        tabLinks.forEach(t => t.classList.remove('is-active'));
        tabContents.forEach(c => c.classList.add('hidden', 'is-active'));

        tab.classList.add('is-active');
        const targetContent = document.querySelector(tab.getAttribute('href'));
        if(targetContent) {
          targetContent.classList.remove('hidden');
          targetContent.classList.add('is-active');
        }
      });
    });
  }

  /***
  VARIANT LOGIC
  ***/
  const productForm = document.getElementById('product-form');

  if (productForm) {
    const productData = window.myApp.product;
    const sizeOptionName = window.myApp.sizeOptionName;

    const variantInput = document.getElementById('selected-variant-id');
    const priceElement = document.getElementById('product-price');
    const moneyFormat = window.myApp.moneyFormat;

    function formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = (format || this.money_format);

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = precision === undefined ? 2 : precision;
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number == null) return 0;

        number = (number / 100).toFixed(precision);
        let parts = number.split('.');
        let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);

        return dollars + (parts[1] ? decimal + parts[1] : '');
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount': value = formatWithDelimiters(cents, 2); break;
        case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    const updateVariantData = () => {
      const selectedSizeRadio = document.querySelector(`input[name="id"]:checked`);

      const sizeLabels = document.querySelectorAll(`label[for^="option-${sizeOptionName}-"]`);
      sizeLabels.forEach(l => l.classList.remove('size-selected'));

      if (selectedSizeRadio) {
        const selectedLabel = document.querySelector(`label[for="${selectedSizeRadio.id}"]`);
        selectedLabel?.classList.add('size-selected');

        const variantId = parseInt(selectedSizeRadio.value, 10);
        const selectedVariant = productData.variants.find(v => v.id === variantId);

        if (selectedVariant) {
          variantInput.value = selectedVariant.id;
          priceElement.textContent = formatMoney(selectedVariant.price, moneyFormat);

          const skuElement = document.getElementById('sku');
          if (skuElement) {
            skuElement.textContent = window.myApp.productSkuTitle + ": " + selectedVariant.sku;
          }
        }
      } else {
        if (variantInput) {
          variantInput.value = '';
        }
      }
    };

    const initialize = () => {
      const allSizeRadios = document.querySelectorAll('input[name="id"]');
      allSizeRadios.forEach(radio => {
        radio.checked = false;
      });
      if (variantInput) {
        variantInput.value = '';
      }

      const sizeLabels = document.querySelectorAll(`label[for^="option-${sizeOptionName}-"]`);
      sizeLabels.forEach(l => l.classList.remove('size-selected'));
    };

    productForm.addEventListener('change', updateVariantData);
    initialize();
  }

  // Sync selected variant ID with URL query parameter
  const sizeInputs = document.querySelectorAll('input[name="id"]');
  sizeInputs.forEach(input => {
    input.addEventListener('change', function() {
      if (this.checked) {
        const variantId = this.value;
        if (variantId) {
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set('variant', variantId);
          window.history.replaceState({ path: newUrl.href }, '', newUrl.href);
        }
      }
    });
  });

  /***
  IMAGE ZOOM LOGIC
  ***/
  const productGallery = document.getElementById('product-gallery');
  const zoomOverlay = document.querySelector('.zoom-overlay');
  const zoomImageContainer = document.querySelector('.zoom-image-container');
  const zoomImage = document.getElementById('zoomed-image');
  const closeZoomButton = document.querySelector('.zoom-overlay-close');
  const thumbnailsContainer = document.querySelector('.productView-thumbs');
  const thumbnailLinks = document.querySelectorAll('.productView-thumbnail-link');

  const productImages = window.myApp.productImages;

  if (productGallery && zoomOverlay && productImages.length > 0) {
    const galleryImages = productGallery.querySelectorAll('.product-image-wrapper');

    galleryImages.forEach((wrapper, index) => {
      wrapper.addEventListener('click', () => {
        const image = productImages[index];

        if (image) {
          zoomImage.src = image.src;
          zoomImage.style.transformOrigin = '50% 50%';
          zoomImage.style.transform = 'scale(1)';

          document.body.classList.add('zoomedImageOpen');
          zoomOverlay.style.display = 'block';

          updateActiveThumbnail(image.id);
        }
      });
    });

    zoomImage.addEventListener('click', function(event) {
      const isDeepZoomed = zoomImageContainer.classList.contains('is-deep-zoomed');

      if (isDeepZoomed) {
        zoomImage.style.transformOrigin = '50% 50%';
        zoomImage.style.transform = 'scale(1)';
        zoomImageContainer.classList.remove('is-deep-zoomed');
      } else {
        const rect = zoomImage.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        const xPercent = (x / rect.width) * 100;
        const yPercent = (y / rect.height) * 100;

        zoomImage.style.transformOrigin = `${xPercent}% ${yPercent}%`;
        zoomImage.style.transform = 'scale(2)';
        zoomImageContainer.classList.add('is-deep-zoomed');
      }
    });

    const closeZoom = () => {
      document.body.classList.remove('zoomedImageOpen');
      zoomOverlay.style.display = 'none';
      zoomImage.style.transformOrigin = '50% 50%';
      zoomImage.style.transform = 'scale(1)';
      zoomImageContainer.classList.remove('is-deep-zoomed');
    }

    closeZoomButton.addEventListener('click', closeZoom);
    document.addEventListener('keydown', (e) => {
      if (e.key === "Escape") {
        closeZoom();
      }
    });

    const updateActiveThumbnail = (activeId) => {
      thumbnailLinks.forEach(link => {
        link.classList.remove('is-active');
        if (parseInt(link.dataset.imageId, 10) === activeId) {
          link.classList.add('is-active');
        }
      });
    };

    thumbnailLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();

        zoomImage.style.transformOrigin = '50% 50%';
        zoomImage.style.transform = 'scale(1)';
        zoomImageContainer.classList.remove('is-deep-zoomed');

        const newSrc = this.href;
        const imageId = this.dataset.imageId;
        zoomImage.src = newSrc;
        updateActiveThumbnail(parseInt(imageId, 10));
      });
    });
  }

  /***
  MOBILE GALLERY SCROLL + ARROWS + DRAG - TRUE INFINITE
  ***/

  const prevBtn = document.getElementById('gallery-prev');
  const nextBtn = document.getElementById('gallery-next');

  if (productGallery) {
    const isMobile = () => window.innerWidth < 767;
    const getScrollAmount = () => productGallery.clientWidth;

    let isScrolling = false;
    let infiniteScrollInitialized = false;

    const removeClones = () => {
      productGallery.querySelectorAll('.clone').forEach(clone => clone.remove());
    };

    const setupInfiniteScroll = () => {

      if (!isMobile()) {
        removeClones();
        infiniteScrollInitialized = false;
        return;
      }

      if (infiniteScrollInitialized) return;

      const galleryItems = Array.from(productGallery.children).filter(
          item => !item.classList.contains('clone')
      );

      galleryItems.forEach(item => {
        const clone = item.cloneNode(true);
        clone.classList.add('clone');
        productGallery.appendChild(clone);
      });

      [...galleryItems].reverse().forEach(item => {
        const clone = item.cloneNode(true);
        clone.classList.add('clone');
        productGallery.insertBefore(clone, productGallery.firstChild);
      });

      const originalSetWidth = productGallery.scrollWidth / 3;

      productGallery.scrollLeft = originalSetWidth;

      const handleInfiniteScroll = () => {

        if (isScrolling) return;
        if (productGallery.scrollLeft >= originalSetWidth * 2) {
          isScrolling = true;
          productGallery.style.scrollBehavior = 'auto';
          productGallery.scrollLeft -= originalSetWidth;
          setTimeout(() => {
            productGallery.style.scrollBehavior = 'smooth';
            isScrolling = false;
          }, 50);
        }

        if (productGallery.scrollLeft <= 0) {
          isScrolling = true;
          productGallery.style.scrollBehavior = 'auto';
          productGallery.scrollLeft += originalSetWidth;
          setTimeout(() => {
            productGallery.style.scrollBehavior = 'smooth';
            isScrolling = false;
          }, 50);
        }
      };

      productGallery.addEventListener('scroll', handleInfiniteScroll);
      infiniteScrollInitialized = true;
    };

    window.addEventListener('load', setupInfiniteScroll);

    window.addEventListener('resize', () => {
      if (!isMobile()) {
        removeClones();
        infiniteScrollInitialized = false;
      } else {
        setupInfiniteScroll();
      }
    });

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => {
        productGallery.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });
      nextBtn.addEventListener('click', () => {
        productGallery.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });
    }
  }

  /***
  ADD TO CART
  ***/
  const addToCartButton = document.getElementById('add-to-cart-button');

  if (productForm && addToCartButton) {

    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const formData = new FormData(productForm);
      const variantId = formData.get('id');

      if (!variantId) {
        alert('Seleziona una taglia prima di procedere con l\'acquisto.');
        return;
      }

      let originalValue;

      try {
        addToCartButton.disabled = true;
        originalValue = addToCartButton.value;
        addToCartButton.value = 'Adding...';

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(productForm)
        });

        if (!res.ok) throw new Error('Add to cart failed');

        if (typeof window.refreshMiniCart === 'function') {
          await window.refreshMiniCart();
        } else {
          const cart = await (await fetch('/cart.js')).json();
          window.updateCartCount?.();
          window.dispatchEvent(new CustomEvent('cart:updated', {
            detail: cart
          }));
        }

        window.openMinicart?.();

      } catch (err) {
        console.error(err);
      } finally {
        addToCartButton.disabled = false;
        addToCartButton.value = originalValue || 'Add to cart';
      }
    });
  }

});
